import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h6twg7gbrb: FaireBrandEntity = {
  token: "b_h6twg7gbrb",
  type: "brand",
  name: "Mini Wardrobes",
  avatarUrl:
    "https://cdn.faire.com/fastly/32c1b477620049e43f52eb2c19ef1229ab369bbeae8a08d942d54369f2332e01.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/734faa4161b5c1bf1a2da92dad2c75405877a4e186f80dbd55b1c64e16e0bd36.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/32c1b477620049e43f52eb2c19ef1229ab369bbeae8a08d942d54369f2332e01.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/734faa4161b5c1bf1a2da92dad2c75405877a4e186f80dbd55b1c64e16e0bd36.jpeg",
  location: "Oakville, ON, CAN",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 38,
  isInsider: false,
  description:
    "Mini Wardrobes was founded by a wife and husband duo in the suburbs of Toronto, Ontario. We were inspired to start a children’s clothing line soon after we had our first child and we were looking for stylish, comfortable and excellent quality clothing at reasonable prices.\n\nOur design approach primarily centres around bringing vibrant colours, eye-catching patterns and prints, as well as subtle and sophisticated colour palettes to both classic and trendy styles of clothing. We are dedicated to making amazing clothing for babies and young children and we hope that these styles will bring a true sense of comfort to your little ones. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:02.089Z",
    importedBy: "entity-db-cli",
  },
};
